import EmailValidationComponent from "@components/find/EmailValidationComponent";

interface FindEmailProps {
  setStep: (step: number) => void;
}

const FindEmail = ({ setStep }: FindEmailProps) => {
  return (
    <div>
      <EmailValidationComponent
        setStep={setStep}
        title="이메일을 입력해주세요."
        fieldName="findemail"
        modalMessage="입력하신 이메일로 링크가 전송되었습니다."
        subMessage="확인 후 비밀번호를 변경해주세요."
        type="findPassword"
      />
    </div>
  );
};

export default FindEmail;
